import { useEffect } from 'react';

import { useNavigation } from '@react-navigation/native';

import { useParentGestureLock } from '@/hooks/use-parent-gesture-lock';
import { usePreventAndroidBackNavigation } from '@/hooks/use-prevent-android-back-navigation';

/**
 * Keeps the user on this screen while `busy`, so the request's per-call callbacks still run
 */
export const useBlockLeavingWhileBusy = (busy: boolean) => {
    const navigation = useNavigation();

    useParentGestureLock(busy);
    usePreventAndroidBackNavigation(busy);

    useEffect(() => {
        if (!busy) {
            return;
        }
        navigation.setOptions({ gestureEnabled: false });
        return () => navigation.setOptions({ gestureEnabled: true });
    }, [busy, navigation]);
};
